// extracted by mini-css-extract-plugin
export default {"wrapper":"createPlaylist_wrapper__w7vYI","header":"createPlaylist_header__kjD0m","footer":"createPlaylist_footer__EGc4Z"};